App.DeliveryZonesRestaurantCreateZoneController = Em.Controller.extend
  needs: [ 'deliveryZones', 'deliveryZonesRestaurantZone']
  session: Em.inject.service()

  zonesBinding:        'controllers.deliveryZones.zones'
  restaurantBinding:   'controllers.deliveryZones.selectedRestaurant'
  selectedZoneBinding: 'controllers.deliveryZones.selectedZone'

  actions:
    cancelCreation: ->
      @transitionToRoute('delivery.zones.restaurant', @get('restaurant'))
      false

    ###
    # Для создания зоны
    ###
    templateSelected: (zone) ->
      @get('zones').pushObject(zone)

      if @get('zones.length') is 1
        @set('controllers.deliveryZonesRestaurantZone.helpPopupIsOpen', true)

      this.transitionToRoute('delivery.zones.restaurant.zone',
        zone.get('restaurant'), zone)
      false

    drawZoneSelected: (restaurant) ->
      organization = @get('session.currentOrganization')

      zone = @store.createRecord 'delivery-zone',
        # todo i18n
        name: Em.I18n.t 'zone_templates.new_object_default_name.delivery'
        restaurant: restaurant
        organization: organization
        delivery_time:       0
        transportation_time: 0
        cooking_time:        0
        price: 0

      zone.save()
        .then =>
          @transitionToRoute('delivery.zones.restaurant.zone',
            zone.get('restaurant'), zone)
      false
